import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import 'vant/lib/index.css';
import '@/assets/style.css';
import "@/assets/fonts/icon.css";

import {Field, Cell, CellGroup, Button, Toast, Icon, Image as VanImage, Tab, Tabs, NoticeBar, List, PullRefresh, Loading, Highlight, Overlay  } from 'vant';
import {user_http, captcha_http, v_http} from "@/utils/http";
import { createPinia } from 'pinia';
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate';
const app = createApp(App);
const pinia = createPinia();
pinia.use(piniaPluginPersistedstate);
store.commit('initialiseStore')

app.use(store);
app.use(pinia);
app.use(router);
app.use(Field).use(CellGroup).use(Cell).use(Button).use(Toast).use(Icon).use(VanImage).use(Tab).use(Tabs).use(NoticeBar).use(List).use(PullRefresh).use(Loading).use(Highlight).use(Overlay);
app.config.globalProperties.$user_http = user_http;
app.config.globalProperties.$captcha_http = captcha_http;
app.config.globalProperties.$v_http = v_http;
app.config.globalProperties.$toast = Toast;
app.mount('#app')


